var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"map",staticClass:"aba-map h-x3",attrs:{"center":_vm.latLng,"zoom":_vm.zoom,"options":_vm.mapOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }